<script>
export default {
  name: 'MessageReactionChips',
  props: {
    reactions: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['select'],
  computed: {
    visibleReactions() {
      return this.reactions.filter(
        reaction => reaction?.emoji && reaction.count
      );
    },
  },
};
</script>

<template>
  <div>
    <div v-if="visibleReactions.length" class="reaction-chip-list">
      <button
        v-for="reaction in visibleReactions"
        :key="reaction.emoji"
        type="button"
        class="reaction-chip"
        :class="{ 'is-mine': reaction.reacted_by_me }"
        @click.stop="$emit('select', reaction.emoji)"
      >
        <span class="reaction-chip__emoji">{{ reaction.emoji }}</span>
        <span class="reaction-chip__count">{{ reaction.count }}</span>
      </button>
    </div>
  </div>
</template>

<style scoped lang="scss">
.reaction-chip-list {
  @apply mt-1 flex flex-wrap gap-1;
}

.reaction-chip {
  @apply inline-flex h-6 items-center gap-1 rounded-full border border-[#e6e6e6] bg-white px-2 text-xs leading-none text-[#0d0d0d] shadow-sm transition-colors hover:bg-[#f7f7f7];
}

.reaction-chip.is-mine {
  @apply border-[#d9d9d9] bg-[#f7f7f7] text-[#0d0d0d];
  box-shadow:
    inset 0 0 0 1px rgba(13, 13, 13, 0.04),
    0 1px 4px rgba(15, 23, 42, 0.08);
}

.reaction-chip__emoji {
  @apply text-sm leading-none;
}

.reaction-chip__count {
  @apply min-w-2 text-center font-medium;
}
</style>
